export function XeroSupportCtrl ($http, $uibModal, $scope, $window, $translate, confirm, messages, workshopAPI, XeroSupport, AdminDashboard) {

  $scope.XeroSupport = new XeroSupport();
  $scope.AdminDashboard = new AdminDashboard();

  workshopAPI.get('/workshop_admin/supportTypes').then(function (data) {
    $scope.contact_type_list = data.xero_contact_types;
    $scope.invoice_type_list = data.xero_invoice_types;
    $scope.payment_type_list = data.xero_payment_types;
  });

  //$scope.contact_type_list = supportTypes.xero_contact_types;

  $scope.find_payments_for_invoice = {
    invoice_number: '',
    record_type: '',
    run: function() {
      workshopAPI.get('/xero/find_payments_for_invoice', [$scope.company.id, this.invoice_number, this.record_type]).then(function (data) {
        $scope.payments = data;
      }).then(function() {
        return $scope.XeroSupport.find_payments_for_invoice($scope.payments);
      }, function (err) {
        messages.error(err);
      });
    }
  };

  $scope.find_contact_by_id = {
    contact_id: '',
    contact_type: '',
    run: function() {
      workshopAPI.get('/xero/find_contact_by_id', [$scope.company.id, this.contact_id, this.contact_type]).then(function (data) {
        $scope.contact = data;
      }).then(function() {
        return $scope.XeroSupport.find_contact_by_id($scope.contact);
      }, function (err) {
        messages.error(err);
      });
    },
    get_id: function() {
      return $scope.AdminDashboard.get_id_for_support($scope.company).then(function(data) {
          $scope.find_contact_by_id.contact_id = data.record.id;
          $scope.find_contact_by_id.contact_type = data.type;
      })

    }
  };


  $scope.find_single_invoice = {
    record_type: 'WI',
    invoice_number: '',
    run: function() {
      workshopAPI.get('/xero/find_single_record', [$scope.company.id, this.record_type, this.invoice_number]).then(function (data) {
        $scope.invoice = data;
      }).then(function() {
        return $scope.XeroSupport.find_invoice_by_invoice_number($scope.invoice);
      }, function (err) {
        messages.error(err);
      });
    }
  };

  $scope.upload_and_response = {
    id: '',
    get_id: function() {
      return $scope.AdminDashboard.get_id_for_support($scope.company).then(function(data) {
          $scope.upload_and_response.id = data.record.id;
      })

    },
    customer: function() {
      workshopAPI.get('/xero/upload_and_response', [$scope.company.id, 'Customer', this.id]).then(function (data) {
        $scope.result = data;
      }).then(function() {
        return $scope.XeroSupport.upload_and_response($scope.result);
      }, function(err) {
        messages.error(err);
      })
    },
    vendor: function() {
      workshopAPI.get('/xero/upload_and_response', [$scope.company.id, 'Vendor', this.id]).then(function (data) {
        $scope.result = data;
      }).then(function() {
        return $scope.XeroSupport.upload_and_response($scope.result);
      }, function(err) {
        messages.error(err);
      })
    },
    invoice: function() {
      workshopAPI.get('/xero/upload_and_response', [$scope.company.id, 'Invoice', this.id]).then(function (data) {
        $scope.result = data;
      }).then(function() {
        return $scope.XeroSupport.upload_and_response($scope.result);
      }, function(err) {
        messages.error(err);
      })
    },
    vendor_invoice: function() {
      workshopAPI.get('/xero/upload_and_response', [$scope.company.id, 'VendorInvoice', this.id]).then(function (data) {
        $scope.result = data;
      }).then(function() {
        return $scope.XeroSupport.upload_and_response($scope.result);
      }, function(err) {
        messages.error(err);
      })
    },
    credit: function() {
      workshopAPI.get('/xero/upload_and_response', [$scope.company.id, 'Credit', this.id]).then(function (data) {
        $scope.result = data;
      }).then(function() {
        return $scope.XeroSupport.upload_and_response($scope.result);
      }, function(err) {
        messages.error(err);
      })
    },
    credit_refund: function() {
      workshopAPI.get('/xero/upload_and_response', [$scope.company.id, 'CreditRefund', this.id]).then(function (data) {
        $scope.result = data;
      }).then(function() {
        return $scope.XeroSupport.upload_and_response($scope.result);
      }, function(err) {
        messages.error(err);
      })
    },
    credit_application_item: function() {
      workshopAPI.get('/xero/upload_and_response', [$scope.company.id, 'CreditApplicationItem', this.id]).then(function (data) {
        $scope.result = data;
      }).then(function() {
        return $scope.XeroSupport.upload_and_response($scope.result);
      }, function(err) {
        messages.error(err);
      })
    },
    vendor_credit: function() {
      workshopAPI.get('/xero/upload_and_response', [$scope.company.id, 'VendorCredit', this.id]).then(function (data) {
        $scope.result = data;
      }).then(function() {
        return $scope.XeroSupport.upload_and_response($scope.result);
      }, function(err) {
        messages.error(err);
      })
    },
    vendor_credit_application_item: function() {
      workshopAPI.get('/xero/upload_and_response', [$scope.company.id, 'VendorCreditApplicationItem', this.id]).then(function (data) {
        $scope.result = data;
      }).then(function() {
        return $scope.XeroSupport.upload_and_response($scope.result);
      }, function(err) {
        messages.error(err);
      })
    },
    customer_payment_dispersal: function() {
      workshopAPI.get('/xero/upload_and_response', [$scope.company.id, 'CustomerPaymentDispersal', this.id]).then(function (data) {
        $scope.result = data;
      }).then(function() {
        return $scope.XeroSupport.upload_and_response($scope.result);
      }, function(err) {
        messages.error(err);
      })
    },
    vendor_payment: function() {
      workshopAPI.get('/xero/upload_and_response', [$scope.company.id, 'VendorPayment', this.id]).then(function (data) {
        $scope.result = data;
      }).then(function() {
        return $scope.XeroSupport.upload_and_response($scope.result);
      }, function(err) {
        messages.error(err);
      })
    }
  };

  $scope.clear_all_non_existing_contacts = {
    run: function() {
      workshopAPI.get('/xero/clear_all_non_existing_contacts', [$scope.company.id]).then(function (result) {
        if (result == true) {
          messages.show($translate.instant('JS_SPACE.MESSAGES.ALL_NON_EXISITING_CLEARED_SUCCESSFUL'), 'success');
        }
      }, function (err) {
        messages.error(err);
      });
    }

  };

  $scope.clear_contact_by_id = {
    contact_id: '',
    run: function() {
      workshopAPI.get('/xero/clear_contact_if_not_found', [$scope.company.id, this.contact_id]).then(function (data) {
        $scope.contact = data;
      }).then(function() {
        return $scope.XeroSupport.clear_contact_if_not_found($scope.contact);
      }, function (err) {
        messages.error(err);
      });
    },
    get_id: function() {
      return $scope.AdminDashboard.get_id_for_support($scope.company).then(function(data) {
          $scope.clear_contact_by_id.contact_id = data.record.id;
      })

    }
  };

  $scope.find_matches_for_invoice = {
    invoice_id: '',
    run: function() {
      workshopAPI.get('/xero/find_matches_for_invoice', [$scope.company.id, this.invoice_id]).then(function (data) {
        $scope.invoice = data;
      }).then(function() {
        return $scope.XeroSupport.find_matches_for_invoice($scope.invoice);
      }, function (err) {
        messages.error(err);
      });
    },
    get_id: function() {
      return $scope.AdminDashboard.get_id_for_support($scope.company).then(function(data) {
          $scope.find_matches_for_invoice.invoice_id = data.record.id;
      })

    }
  };

  $scope.sync_down_log= {
    payment_type: '',
    run: function() {
      workshopAPI.get('/xero/sync_down_log', [$scope.company.id, this.payment_type, 'ws']).then(function (result) {
        if (result == true) {
          messages.show($translate.instant('JS_SPACE.MESSAGES.PAYMENT_SYNC_SUCCESSFUL'), 'success');
        }
      }, function (err) {
        messages.error(err);
      });
    }

  };

}